export class Utilities {
  static formatByte(byte: number) {
    return '0x' + byte.toString(16).toUpperCase();
  }
}
